import { DataTableColumnHeader } from "@/shared/components/table";
import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { FacebookResourceTargetDateRow } from "../types/preferences_types";

export function useFacebookResourceTargetDateColumns() {
    return useMemo<ColumnDef<FacebookResourceTargetDateRow>[]>(
        () => [
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                        onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(v) => row.toggleSelected(!!v)}
                        aria-label="Select row"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
                size: 50,
                minSize: 50,
                maxSize: 50,
                enableSorting: false,
                enableHiding: false,
                enableResizing: false,
            },
            {
                accessorKey: "adAccountId",
                header: ({ column }) => <DataTableColumnHeader column={column} title="ad_account_id" />,
            },
            {
                accessorKey: "targetDate",
                header: ({ column }) => <DataTableColumnHeader column={column} title="비교 일자" />,
            },
        ],
        []
    );
}